var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hole-hint-control"},[_c('div',{staticClass:"hole-hint"},[_c('IxRes',[_vm._v("frs.geometryEditing.hints.holeDrawing")]),_c('IxRes',[_vm._v("frs.geometryEditing.hints.vertexRemoval")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }